import React from 'react';
import './DefaultPage.css';

const DefaultPage = () => {
    return (
        <div className="page-content">
            <h1>Avi Medical REST API Documentation</h1>
            <p>Please select one of the sections from the menu on the left to see the respective documentation.</p>
        </div>
    );
}

export default DefaultPage;
